var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"widget widget-section",attrs:{"data-field":_vm.fieldName,"id":_vm.fieldName}},[_c('p',{class:['label', _vm.subSection ? 'sub-label' : '' ]},[_vm._v(_vm._s(_vm.value))]),_vm._v(" "),_c('p',{staticClass:"sub-label"},[_vm._v(_vm._s(_vm.help))])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-bf3c794c","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/questionnaires/widgets/SectionWidget.vue
// module id = nQFH
// module chunks = 1